export default __webpack_public_path__ + "static/media/slide1.de5ece09.jpg";